// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"uW-z","sponsoredTooltipWrapper":"vW-z","sponsoredTooltip":"wW-z","newCard":"xW-z"};